import apolloClient from '@/lib/apollo-client';
import { GET_USER_BY_ID, GET_PROFILE_PIC } from '@/lib/graphql/queries';
import { getCookie } from '@/utils/cookies';
import { Profile } from './profileService';

export const getUserById = async (id: string): Promise<Profile> => {
  const token = getCookie('token');
  try {
    const { data } = await apolloClient.query({
      query: GET_USER_BY_ID,
      variables: { id: parseInt(id, 10) }, // Convert string ID to integer
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      fetchPolicy: 'network-only' // Don't use cache for user profiles
    });

    return data.getUserById;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

export const getUserProfilePicture = async (filename: string) => {
  const token = getCookie('token');
  try {
    const { data } = await apolloClient.query({
      query: GET_PROFILE_PIC,
      variables: { filename },
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      fetchPolicy: 'no-cache' // Don't cache profile pictures
    });

    return data.getProfilePicByName;
  } catch (error) {
    console.error('Error fetching user profile picture:', error);
    throw error;
  }
};